

























































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { WorkerWizardModule } from '@/store/modules/workerWizard';
import FieldValidationCodes from '@/lib/fieldValidationCodes';

@Component({
  name: 'WorkerWizardCvUpload'
})
export default class WorkerWizardCvUpload extends GiganautVueDialog {
  FieldValidationCodes = FieldValidationCodes;

  public dialog = false;
  public uploading = false;
  public completed = false;
  currentFile: any = null;
  payRate = 0;
  formKey = 0;
  summaryFormat = 'bullets';
  markAttributesVerified = false;
  expandedSteps: Record<number, boolean> = { 3: true };
  startTime = 0;
  elapsedSeconds = 0;

  summaryFormatOptions = [
    { label: 'Bullet Points (7-8 key points)', value: 'bullets' },
    { label: 'Paragraphs (2-3 paragraphs)', value: 'paragraphs' }
  ];

  progressSteps = [
    { num: 1, label: 'Uploading document' },
    { num: 2, label: 'Loading positions, skills and qualifications' },
    { num: 3, label: 'Analyzing CV' },
    { num: 4, label: 'Processing results' },
    { num: 5, label: 'Geocoding address' },
    { num: 6, label: 'Finalizing' }
  ];

  get hasWorkTypeSelected(): boolean {
    const workTypes = WorkerWizardModule.newWorker?.worker?.workTypes;
    return workTypes && workTypes.length > 0;
  }

  get isTempSelected(): boolean {
    const workTypes = WorkerWizardModule.newWorker?.worker?.workTypes;
    return workTypes && workTypes.includes('Temp');
  }

  get cvStreamStep(): number {
    return WorkerWizardModule.cvStream.currentStep || 0;
  }

  get cvStreamThinking(): string {
    return WorkerWizardModule.cvStream.thinkingContent || '';
  }

  get cvImportSummary() {
    return WorkerWizardModule.cvImportSummary;
  }

  get summaryPositionCount(): number {
    return this.cvImportSummary ? this.cvImportSummary.positionCount : 0;
  }

  get summarySkillCount(): number {
    return this.cvImportSummary ? this.cvImportSummary.skillCount : 0;
  }

  get summaryQualificationCount(): number {
    return this.cvImportSummary ? this.cvImportSummary.qualificationCount : 0;
  }

  get formattedElapsedTime(): string {
    const minutes = Math.floor(this.elapsedSeconds / 60);
    const seconds = this.elapsedSeconds % 60;
    return `${minutes} minute${minutes !== 1 ? 's' : ''} ${seconds} second${seconds !== 1 ? 's' : ''}`;
  }

  get formattedThinking(): string {
    let content = this.cvStreamThinking;
    if (!content) return '';

    // Escape HTML
    content = content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    // Convert markdown headers
    content = content.replace(/^#### (.+)$/gm, '<div class="think-h4">$1</div>');
    content = content.replace(/^### (.+)$/gm, '<div class="think-h3">$1</div>');
    content = content.replace(/^## (.+)$/gm, '<div class="think-h2">$1</div>');
    content = content.replace(/^# (.+)$/gm, '<div class="think-h1">$1</div>');

    // Convert bold and italic
    content = content.replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>');
    content = content.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    content = content.replace(/\*(.+?)\*/g, '<em>$1</em>');

    // Convert bullet lists
    content = content.replace(/^- (.+)$/gm, '<div class="think-bullet">$1</div>');
    content = content.replace(/^\* (.+)$/gm, '<div class="think-bullet">$1</div>');

    // Convert numbered lists
    content = content.replace(/^\d+\. (.+)$/gm, '<div class="think-numbered">$1</div>');

    // Convert line breaks
    content = content.replace(/\n\n/g, '<div class="think-break"></div>');
    content = content.replace(/\n/g, '<br>');

    return content;
  }

  isStepComplete(stepNum: number): boolean {
    return this.completed || this.cvStreamStep > stepNum;
  }

  isStepActive(stepNum: number): boolean {
    return !this.completed && this.cvStreamStep === stepNum;
  }

  isStepPending(stepNum: number): boolean {
    return !this.completed && this.cvStreamStep < stepNum;
  }

  getStepClass(stepNum: number): object {
    return {
      'step-complete': this.isStepComplete(stepNum),
      'step-active': this.isStepActive(stepNum),
      'step-pending': this.isStepPending(stepNum)
    };
  }

  toggleStep(stepNum: number) {
    if (stepNum === 3) {
      this.$set(this.expandedSteps, stepNum, !this.expandedSteps[stepNum]);
    }
  }

  async save(){
    if (!this.currentFile) {
      return;
    }

    this.uploading = true;
    this.completed = false;
    this.expandedSteps = { 3: true };
    this.startTime = Date.now();
    this.elapsedSeconds = 0;

    try {
      WorkerWizardModule.setCvImportMarkVerified(this.markAttributesVerified);

      // Wait for parsing to complete - returns true on success, false on error
      const success = await WorkerWizardModule.uploadWorkerCVWithStreaming({
        file: this.currentFile,
        payRate: this.payRate,
        summaryFormat: this.summaryFormat
      });

      this.uploading = false;
      if (success) {
        this.elapsedSeconds = Math.round((Date.now() - this.startTime) / 1000);
        this.completed = true;
      } else {
        console.error('CV upload failed:', WorkerWizardModule.cvStream.error);
      }
    } catch (error) {
      console.error('CV upload failed:', error);
      this.uploading = false;
    }
  }

  closeDialog() {
    this.dialog = false;
  }

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    if (val) {
      // Dialog opening - reset state
      this.currentFile = null;
      this.payRate = 0;
      this.summaryFormat = 'bullets';
      this.markAttributesVerified = false;
      this.uploading = false;
      this.completed = false;
      this.expandedSteps = { 3: true };
      this.startTime = 0;
      this.elapsedSeconds = 0;
      WorkerWizardModule.resetCVStreamState();
      this.formKey++;
    } else {
      // Dialog closing - cancel any active streaming subscription
      if (this.uploading && !this.completed) {
        WorkerWizardModule.cancelCVStreaming();
      }
    }
  }

  beforeDestroy() {
    // Clean up Firestore subscription on component destroy
    if (this.uploading && !this.completed) {
      WorkerWizardModule.cancelCVStreaming();
    }
  }

  @Watch('cvStreamThinking')
  onThinkingChanged() {
    if (!this.completed) {
      this.$nextTick(() => {
        const els = this.$refs.thinkingOutput as HTMLElement[] | HTMLElement;
        const el = Array.isArray(els) ? els[0] : els;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    }
  }

  @Watch('cvStreamStep')
  onStepChanged(newStep: number) {
    if (newStep === 3) {
      this.$set(this.expandedSteps, 3, true);
    }
  }
}
